import React from 'react';
import './TermsOfService.css';

interface TermsOfServiceProps {
  className?: string;
}

const TermsOfService: React.FC<TermsOfServiceProps> = ({ className = '' }) => {
  return (
    <div className={`terms-of-service ${className}`}>
      <h2>ĐIỀU KHOẢN THAM GIA TRÒ CHƠI</h2>
      <h2>"VŨ TRỤ KILOBA"</h2>
      
      <section>
        <h3>1. Giới thiệu</h3>
        <p>1.1. Điều khoản sử dụng này ("Điều khoản") quy định việc truy cập, đăng ký và sử dụng trò chơi/tiện ích gamification "VŨ TRỤ KILOBA" và các tính năng liên quan.</p>
        <p>1.2. Chúng tôi có thể sửa đổi Điều khoản này bất kỳ lúc nào, phiên bản cập nhật sẽ được đăng trên kênh fanpage chính thức của Ngân hàng Kiên Long (<a href="https://www.facebook.com/NganhangKienLong" target="_blank" rel="noopener noreferrer">https://www.facebook.com/NganhangKienLong</a>) và có hiệu lực từ thời điểm công bố.</p>
      </section>

      <section>
        <h3>2. Định nghĩa</h3>
        <p>2.1 Nền tảng: Ứng dụng/website của KienlongBank và/hoặc trang mini-app chứa KILOBA.</p>
        <p>2.2 Tài khoản: Tài khoản KienlongBank/KILOBA hoặc định danh liên kết (SĐT, email, ID).</p>
        <p>2.3 Thiết bị: Điện thoại, máy tính bảng, kiosk, màn hình tương tác… dùng để tham gia trò chơi.</p>
        <p>2.4 Nội dung người dùng: Văn bản, hình ảnh, video, dữ liệu do Bạn tạo/đăng trong quá trình chơi.</p>
        <p>2.5 Voucher/Quà tặng: Theo thông báo thể lệ chương trình khuyến mại <a href="https://kienlongbank.com/Data/Sites/1/media/links/the-le-tro-choi-vu-tru-kiloba.pdf" target="_blank" rel="noopener noreferrer">tại đây</a>.</p>
      </section>

      <section>
        <h3>3. Tài khoản & truy cập</h3>
        <p>3.1. Bạn cần đăng ký/đăng nhập để tham gia trò chơi. Thông tin cung cấp phải chính xác, đầy đủ và được cập nhật khi có thay đổi.</p>
        <p>3.2. Mỗi người dùng chỉ sở hữu một tài khoản duy nhất. Chúng tôi có quyền giới hạn số thiết bị đăng nhập đồng thời.</p>
        <p>3.3. Nếu Tài khoản không hoạt động liên tục 45 ngày, Chúng tôi có quyền tạm ngưng/xoá dữ liệu game (không ảnh hưởng tới quan hệ ngân hàng nếu có, trừ khi pháp luật yêu cầu khác).</p>
        <p>3.4. Bạn chịu trách nhiệm bảo mật thông tin đăng nhập và mọi hành vi phát sinh từ Tài khoản của mình.</p>
      </section>

      <section>
        <h3>4. Hành vi bị cấm</h3>
        <p>4.1 Bạn không được:</p>
        <ul>
          <li>a. Can thiệp hệ thống, đảo ngược mã, dùng phần mềm/thiết bị gian lận (auto-click, giả lập, can thiệp cảm biến/QR/RFID…).</li>
          <li>b. Tạo nhiều tài khoản để trục lợi, thao túng bảng xếp hạng, chuyển nhượng/ mua bán tài khoản, voucher.</li>
          <li>c. Đăng tải nội dung vi phạm pháp luật, xâm phạm quyền SHTT, trái thuần phong mỹ tục.</li>
          <li>d. Tấn công, thu thập trái phép dữ liệu người khác, phát tán mã độc, spam.</li>
          <li>e. Mạo danh KienlongBank hoặc sử dụng logo/nhãn hiệu trái phép.</li>
        </ul>
        <p>4.2 Vi phạm có thể bị khóa tài khoản, hủy kết quả/chặng chơi, thu hồi phần thưởng và/hoặc chuyển cơ quan có thẩm quyền khi cần.</p>
      </section>

      <section>
        <h3>5. Thu thập & sử dụng dữ liệu cá nhân</h3>
        <p>5.1. Dữ liệu Bạn cung cấp: SĐT, họ tên, email (nếu có), hình/clip check-in, nhật ký tương tác trong trò chơi.</p>
        <p>5.2. Dữ liệu hệ thống thu thập: thiết bị, hệ điều hành, IP, cookie/ID quảng cáo, sự kiện tương tác, sự cố kỹ thuật.</p>
        <p>5.3. Mục đích:</p>
        <ul>
          <li>a. Vận hành game;</li>
          <li>b. Chống gian lận;</li>
          <li>c. Cá nhân hoá trải nghiệm;</li>
          <li>d. Chăm sóc khách hàng;</li>
          <li>e. Thống kê – cải tiến sản phẩm;</li>
          <li>f. Các hoạt động khác theo quy định;</li>
          <li>g. Tuân thủ yêu cầu pháp luật.</li>
        </ul>
        <p>5.4. Chia sẻ:</p>
        <ul>
          <li>a. Với đơn vị cung cấp hạ tầng kỹ thuật, công ty con/liên kết, đối tác vận hành gamification – trên cơ sở thỏa thuận bảo mật;</li>
          <li>b. Với cơ quan nhà nước theo luật.</li>
        </ul>
        <p>5.5. Thời hạn lưu trữ: theo mục đích nêu trên hoặc theo quy định pháp luật.</p>
        <p>5.6. Quyền của Chủ thể dữ liệu: truy cập, chỉnh sửa, hạn chế/xoá, rút lại đồng ý theo quy trình công bố. Một số yêu cầu có thể ảnh hưởng khả năng tiếp tục tham gia trò chơi.</p>
        <p>5.7. Sự đồng ý của Chủ thể dữ liệu: Bằng việc nhấn "Đồng ý" Chủ thể dữ liệu cho phép Chúng tôi xử lý dữ liệu cá nhân của chủ thể dữ liệu.</p>
        <p>5.8. Trường hợp Bạn là người dưới 16 tuổi, Bạn cần bảo đảm rằng:</p>
        <ul>
          <li>a. Bạn đã được cha, mẹ hoặc người giám hộ hợp pháp/người đại diện theo pháp luật đăng ký và xác thực Tài khoản bằng thông tin của cha, mẹ hoặc người giám hộ hợp pháp/người đại diện theo pháp luật.</li>
          <li>b. Bạn luôn được cha, mẹ hoặc người giám hộ hợp pháp/người đại diện theo pháp luật giám sát và quản lý khi tham gia trò chơi.</li>
          <li>c. Cha, mẹ hoặc người giám hộ hợp pháp của Bạn xác nhận đã đọc, hiểu và chấp thuận Điều khoản này.</li>
        </ul>
      </section>

      <section>
        <h3>6. Phần thưởng – Thể lệ – Bảng xếp hạng</h3>
        <p>6.1. Cơ chế tích điểm, tỷ lệ trúng, mốc nhận quà, thời gian sự kiện và số lượng quà tặng được công bố trên Nền tảng/booth mỗi thời kỳ và có thể thay đổi theo thực tế vận hành.</p>
        <p>6.2. Voucher/Quà tặng không quy đổi thành tiền mặt (trừ khi thể lệ ghi khác), có thời hạn sử dụng, điều kiện áp dụng và có thể yêu cầu xác minh danh tính trước khi trao.</p>
        <p>6.3. Trường hợp lỗi kỹ thuật, nghi vấn gian lận hoặc bất thường dữ liệu, KienlongBank có quyền tạm giữ/huỷ kết quả, log lại giao dịch, yêu cầu chơi lại hoặc điều chỉnh bảng xếp hạng để đảm bảo công bằng.</p>
        <p>6.4. Quyết định của KienlongBank về tính hợp lệ lượt chơi và việc trao thưởng là cuối cùng.</p>
      </section>

      <section>
        <h3>7. Bảo mật & an toàn thông tin</h3>
        <p>7.1. Chúng tôi áp dụng biện pháp kỹ thuật – tổ chức phù hợp để bảo vệ dữ liệu theo tiêu chuẩn cuả pháp luật về an toàn thông tin mạng để bảo vệ dữ liệu người dùng.</p>
        <p>7.2. Tuy nhiên, rủi ro trên Internet luôn tồn tại; Bạn chấp nhận rủi ro hợp lý ngoài khả năng kiểm soát của Chúng tôi. Hãy bảo vệ thiết bị, không chia sẻ OTP/mật khẩu.</p>
      </section>

      <section>
        <h3>8. Quyền sở hữu trí tuệ</h3>
        <p>Mọi quyền SHTT với KILOBA, giao diện, nhân vật, âm thanh, hình ảnh, mã nguồn, tài liệu hướng dẫn… thuộc KienlongBank (trừ Nội dung người dùng hợp pháp). Nghiêm cấm sao chép/sử dụng nếu không được KienlongBank cho phép bằng văn bản.</p>
      </section>

      <section>
        <h3>9. Miễn trừ trách nhiệm</h3>
        <p>9.1. Trò chơi được cung cấp "như hiện có". Chúng tôi không bảo đảm tuyệt đối về gián đoạn, lỗi kỹ thuật, tốc độ, hoặc việc trò chơi đáp ứng mọi kỳ vọng người dùng.</p>
        <p>9.2. KienlongBank không chịu trách nhiệm với tổn thất do:</p>
        <ul>
          <li>a. Thiết bị/ngắt kết nối của người dùng,</li>
          <li>b. Do Bên thứ ba,</li>
          <li>c. Do sự kiện bất khả kháng.</li>
        </ul>
        <p>9.3. Bạn đồng ý bồi thường cho KienlongBank trước khiếu nại của Bên thứ ba phát sinh từ hành vi vi phạm Điều khoản hoặc pháp luật của Bạn.</p>
      </section>

      <section>
        <h3>10. Luật áp dụng & giải quyết tranh chấp</h3>
        <p>Điều khoản chịu sự điều chỉnh của pháp luật Việt Nam. Tranh chấp (nếu có) ưu tiên giải quyết thương lượng; nếu không thành, chuyển cơ quan có thẩm quyền tại Việt Nam.</p>
      </section>

      <section>
        <h3>11. Hiệu lực</h3>
        <p>Điều khoản có hiệu lực từ ngày công bố/ cập nhật trên Nền tảng. Phần nội dung nào xung đột quy định pháp luật hiện hành sẽ được điều chỉnh cho phù hợp; các phần còn lại vẫn giữ nguyên giá trị.</p>
        <p><strong>Bằng việc nhấn Đồng ý/tiếp tục sử dụng, người dùng ("Bạn/Người dùng") xác nhận đã đọc, hiểu và chấp thuận Điều khoản này. Nếu không đồng ý, vui lòng ngừng tham gia trò chơi.</strong></p>
      </section>

      <section>
        <h3>12. Thông tin liên hệ</h3>
        <ul>
          <li>● Kênh hỗ trợ: Kênh hỗ trợ trong ứng dụng KILOBA</li>
          <li>● Email: <a href="mailto:chamsockhachhang@kienlongbank.com">chamsockhachhang@kienlongbank.com</a></li>
        </ul>
      </section>
    </div>
  );
};

export default TermsOfService;